module.exports = __webpack_public_path__ + "img/188.8.374a14ea.png";